import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
const json = {
  1: { // Exercise num
    unit: 'Starter',
    id: 'SB5-V2-S-P5-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page5/E1/Key/answerKey.png',
    component: D1,
    maxLength: 1,
    textAlign: 'center',
    checkUppercase: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page5/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/3.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page5/E1/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/6.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page5/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/8.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page5/E1/9.jpg' },

      ],
      [
        { url: 'img/FriendsPlus/Page5/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/11.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page5/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page5/E1/13.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page5/E1/14.jpg' },

      ],
    ],
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'SB5-V2-S-P5-E2',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    fontSize: 21,
    exerciseKey: 'img/FriendsPlus/Page5/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page5/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/3.jpg', input: true, answer: "taller" },
        { url: 'img/FriendsPlus/Page5/E2/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E2/5.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page5/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/7.jpg', input: true, answer: "faster" },
        { url: 'img/FriendsPlus/Page5/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page5/E2/9.jpg', input: true, answer: "smaller" },
        { url: 'img/FriendsPlus/Page5/E2/10.jpg' },
      ]
    ],
  },
  3: { // Exercise num
    unit: 'Starter',
    id: 'SB5-V2-S-P5-E3',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    textAlign: 'center',
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page5/E3/Key/answerKey.png',
    questionImage: [ // Row

      [
        // Column1
        { url: 'img/FriendsPlus/Page5/E3/24.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page5/E3/25.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page5/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page5/E3/27.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page5/E3/28.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page5/E3/29.jpg' },
        { url: 'img/FriendsPlus/Page5/E3/30.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page5/E3/31.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page5/E3/32.jpg' },
        { url: 'img/FriendsPlus/Page5/E3/33.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page5/E3/34.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page5/E3/35.jpg' },
        { url: 'img/FriendsPlus/Page5/E3/36.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page5/E3/37.jpg' },
      ],
    ],
  },
}

export default json;